import React from 'react';

const CentClock: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3335 26.6667V20H19.3335V26.6667C19.3335 27.4647 20.0063 28.4563 21.7095 29.3079C23.3529 30.1296 25.6934 30.6667 28.3335 30.6667C30.9736 30.6667 33.3141 30.1296 34.9575 29.3079C36.6607 28.4563 37.3335 27.4647 37.3335 26.6667V20H39.3335V26.6667C39.3335 28.6303 37.7679 30.1387 35.852 31.0967C33.8762 32.0846 31.2167 32.6667 28.3335 32.6667C25.4503 32.6667 22.7908 32.0846 20.815 31.0967C18.8991 30.1387 17.3335 28.6303 17.3335 26.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3335 33.3333V26.6667H19.3335V33.3333C19.3335 34.1314 20.0063 35.1229 21.7095 35.9745C23.3529 36.7962 25.6934 37.3333 28.3335 37.3333C30.9736 37.3333 33.3141 36.7962 34.9575 35.9745C36.6607 35.1229 37.3335 34.1314 37.3335 33.3333V26.6667H39.3335V33.3333C39.3335 35.2969 37.7679 36.8054 35.852 37.7634C33.8762 38.7512 31.2167 39.3333 28.3335 39.3333C25.4503 39.3333 22.7908 38.7512 20.815 37.7634C18.8991 36.8054 17.3335 35.2969 17.3335 33.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7096 17.3589C20.0063 18.2106 19.3335 19.2021 19.3335 20C19.3335 20.7979 20.0063 21.7894 21.7096 22.6411C23.3532 23.4629 25.6937 24 28.3335 24C30.9733 24 33.3138 23.4629 34.9574 22.6411C36.6607 21.7894 37.3335 20.7979 37.3335 20C37.3335 19.2021 36.6607 18.2106 34.9574 17.3589C33.3138 16.5371 30.9733 16 28.3335 16C25.6937 16 23.3532 16.5371 21.7096 17.3589ZM20.8152 15.57C22.791 14.5822 25.4505 14 28.3335 14C31.2165 14 33.876 14.5822 35.8518 15.57C37.7677 16.528 39.3335 18.0365 39.3335 20C39.3335 21.9635 37.7677 23.472 35.8518 24.43C33.876 25.4178 31.2165 26 28.3335 26C25.4505 26 22.791 25.4178 20.8152 24.43C18.8993 23.472 17.3335 21.9635 17.3335 20C17.3335 18.0365 18.8993 16.528 20.8152 15.57Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3335 7.33331V14.3333H7.3335V12.3333H12.3335V7.33331H14.3335Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3334 2.66666C7.44237 2.66666 2.66675 7.44228 2.66675 13.3333C2.66675 19.2244 7.44237 24 13.3334 24H14.3334V26H13.3334C6.3378 26 0.666748 20.3289 0.666748 13.3333C0.666748 6.33771 6.3378 0.666656 13.3334 0.666656C19.0729 0.666656 23.9193 4.48411 25.4753 9.71662L25.7603 10.6751L23.8433 11.2452L23.5582 10.2867C22.2476 5.8792 18.1639 2.66666 13.3334 2.66666Z"
      />
    </svg>
  );
};

export default CentClock;
